import { Directive, ElementRef, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * Add this directive with [matTooltip] if you want the tooltip to be displayed only if the element is truncated.
 * ex: overflow hidden + ellipsis for a text
 */
@Directive({
  selector: '[matTooltip][appMatTooltipShowIfTruncated]',
})
export class MatTooltipShowIfTruncatedDirective {
  constructor(private matTooltip: MatTooltip, private elementRef: ElementRef<HTMLElement>) {}

  @HostListener('mouseenter', ['$event'])
  setTooltipState(): void {
    const element = this.elementRef.nativeElement;
    this.matTooltip.disabled = element.scrollWidth <= element.clientWidth;
  }
}
